module.exports = __webpack_public_path__ + "img/about__worth-img——vi.628224f1.png";